module.exports = __webpack_public_path__ + "img/98.59b25fdc.png";